import React from 'react'
import style from './index.module.less'
import { XrealLogoWhite, Media1, Media2, Media3, Media4, Media5, } from '@/images/index'
import { useIntl } from 'react-intl'
import useNavigateLink from "@/hooks/useNavigateLink";


const SocialMedia = () => {
  const intl = useIntl()
  const navigateLink = useNavigateLink

  const medias = [
    {
      id: 1,
      img: Media1,
      link: intl.locale === 'ja' ? process.env.url_twitter_jp : process.env.url_twitter,
      outlink: true
    },
    {
      id: 2,
      img: Media2,
      link: intl.locale === 'ja' ? process.env.url_discord_jp : process.env.url_discord,
      outlink: true
    },
    {
      id: 3,
      img: Media3,
      link: process.env.url_reddit,
      outlink: true
    },{
      id: 4,
      img: Media4,
      link: intl.locale === 'ja' ? process.env.url_ins_jp : process.env.url_ins,
      outlink: true
    },
    {
      id: 5,
      img: Media5,
      link: intl.locale === 'ja' ? process.env.url_youtube_jp : process.env.url_youtube,
      outlink: true
    }]

    const getLinkUrl = (link) => {
      const url = navigateLink(link)
      return url
    }

  return (
    <div className={style.socialMedia}>
      <XrealLogoWhite className={style.logo} />

      <div className={style.mediaIcons}>
        {medias.map((item) => 
          (<div className={style.mediaIconItem} style={{background: `url(${item.img})`}} key={item.id}>
              {item.outlink ? <a href={item.link} className={style.alink} target='_blank'>{item.name}</a> : 
              <Link to={getLinkUrl(item.link)}>
                {item.name}
              </Link>}
          </div>)
        )}
      </div>
    </div>
  )
}

export default SocialMedia
